"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.payloadDecoder = void 0;
var ts_data_json_1 = require("ts.data.json");
exports.payloadDecoder = ts_data_json_1.JsonDecoder.object({
    service: ts_data_json_1.JsonDecoder.oneOf([ts_data_json_1.JsonDecoder.isExactly('slack'), ts_data_json_1.JsonDecoder.isExactly('github')], 'Service'),
}, 'DisconnectProfile.Payload');
